import * as React from 'react'

import SortByPanel from '../panels/SortByPanel'
import { ISortByPanelProps } from '../types'
import OptionsPopoverShell from './OptionsPopoverShell'

interface IProps extends Omit<ISortByPanelProps, 'onClose'> {
  open: boolean
  onOpenChange: (open: boolean) => void
  children: React.ReactNode
  side?: 'top' | 'bottom' | 'left' | 'right'
  align?: 'start' | 'center' | 'end'
  sideOffset?: number
}

const SortByPopover: React.FC<IProps> = ({
  open,
  onOpenChange,
  children,
  side,
  align,
  sideOffset,
  ...panelProps
}) => {
  return (
    <OptionsPopoverShell
      open={open}
      onOpenChange={onOpenChange}
      trigger={children}
      side={side}
      align={align}
      sideOffset={sideOffset}
    >
      <SortByPanel {...panelProps} onClose={() => onOpenChange(false)} />
    </OptionsPopoverShell>
  )
}

export default SortByPopover
